define('lib/theme/ColorSchemeHandler',['require','marionette','less','Config'],function (require) {

    var Marionette = require('marionette');
    var Less = require('less');
    var Config = require('Config');

    return Marionette.Object.extend({

        _styleNodes: {},
        //_styleNodeRtl: null,
        _lessData: null,
        //_lessDataRtl: null,
        _themeSettings: null,

        initialize: function () {
            this._themeSettings = this.getOption('themeSettings');

            this.parseLess();
        },

        parseLess: function () {
            if (!this._styleNodes.color) {
                this.loadLess();
            }

            this._addStyles(this._lessData, this._getStyleNode('color'));
            /*if (Config.getInstance().getOption('is_rtl')) {
                this.parseLessRtl();
            }*/
        },

        /*parseLessRtl: function () {
            this._addStyles(this._lessDataRtl, this._getStyleNode('rtl'));
        },*/

        loadLess: function () {
            var instance = this;
            var revision = Config.getInstance().getOption('revision');
            jQuery.get('/v2/themes/' + this.getOption('theme') + '/css/color-styles.less?r=' + revision, function (lessData) {
                instance._lessData = lessData;
                instance.parseLess();
                /*if (Config.getInstance().getOption('is_rtl')) {
                    jQuery.get('/v2/themes/' + instance.getOption('theme') + '/css/color-styles-rtl.less?r=' + revision, function (lessData) {
                        instance._lessDataRtl = lessData;
                        instance.parseLessRtl();
                    });
                }*/
            });
        },

        _getStyleNode: function (pref) {
            if (!this._styleNodes[pref]) {
                this._styleNodes[pref] = jQuery('<style type="text/css"></style>');
                this._styleNodes[pref].appendTo(jQuery('head'));
            }
            return this._styleNodes[pref];
        },

        // Mirrors themes/assets/less/plugin/img.js's img() function (formerly loaded via a LESS
        // `@plugin` at-rule in the inspiration theme's color-styles.less, now removed there).
        // less.js loads @plugin files by fetching them as text and running `new Function()` on
        // the content -- CSP's script-src blocks that once csp_strict_eval is on, and since the
        // @plugin at-rule sits at the top of the file, the failure aborts the WHOLE Less.render()
        // call, not just the background image (every color/button rule in the file goes
        // unstyled). img()'s own logic is trivial string-building, so it's replicated here in
        // plain JS and passed through globalVars instead -- no eval needed.
        _getPluginImage: function (imgKey, type, defaultImg) {
            var themeVars = window.themeVars || {};
            var imgFileName = themeVars[imgKey + '_file_name'];
            if (imgFileName) {
                return themeVars.upload_path + '/image_files/' + type + '/' + imgFileName;
            }
            return defaultImg;
        },

        _addStyles: function (data, node) {
            if (data) {
                var theme = this.getOption('theme');
                var defaultBg = '../v2/themes/' + theme + '/img/blurred_image.jpg';

                Less.render(data, {
                    globalVars: _.extend({
                        backgroundImage: this._getPluginImage('sb_background_image', 'background', defaultBg),
                        backgroundImageBlur: this._getPluginImage('sb_background_image', 'preview_blur', defaultBg)
                    }, this._themeSettings.getThemeOptions()),
                    useFileCache: true
                }).then(function (css, aa,bb) {
                    node.html(css.css);
                }, function (err) {
                    console.log(err);
                });
            }
        }

    });

});
